import { Fragment, useMemo } from 'react';

import { Filters, FilterComparer } from '@components/filters';

import { useStore } from 'models/Provider';

type FilterComparerList = Array<{ label: string; value: FilterComparer; multi: boolean }>;

export function FilterComparerMenu(props: {
  comparers: Array<FilterComparer>;
  onComparerSelect(comp: FilterComparer): void;
}) {
  const { t } = useStore();
  const { comparers: userFilteredComparers, onComparerSelect } = props;

  const comparers = useMemo(() => {
    const _comparers: FilterComparerList = [
      { label: t('comparers.is'), value: 'is', multi: false },
      { label: t('comparers.not_is'), value: 'not_is', multi: false },
      { label: t('comparers.contains'), value: 'contains', multi: false },
      { label: t('comparers.not_contains'), value: 'not_contains', multi: false },
      { label: t('comparers.any_of'), value: 'any_of', multi: true },
      { label: t('comparers.none_of'), value: 'none_of', multi: true },
      { label: t('comparers.starts'), value: 'starts', multi: false },
      { label: t('comparers.not_starts'), value: 'not_starts', multi: false },

      // For dates
      { label: t('comparers.today'), value: 'today', multi: false },
      { label: t('comparers.yesterday'), value: 'yesterday', multi: false },
      { label: t('comparers.gt'), value: 'gt', multi: false },
      { label: t('comparers.lt'), value: 'lt', multi: false },
      { label: t('comparers.eq'), value: 'eq', multi: false },
      { label: t('comparers.after'), value: 'after', multi: false },
      { label: t('comparers.on'), value: 'on', multi: false },
      { label: t('comparers.before'), value: 'before', multi: false },

      // For ratings
      { label: t('comparers.is_rated_by'), value: 'is_rated_by', multi: false },
      { label: t('comparers.not_is_rated_by'), value: 'not_is_rated_by', multi: false },
    ];

    if (userFilteredComparers.length === 0) return _comparers;
    return _comparers.filter((comparer) => userFilteredComparers.includes(comparer.value));
  }, [userFilteredComparers, t]);

  return (
    <Fragment>
      {comparers.map((v, index) => (
        <Filters.ListItem key={index} label={v.label} onClick={() => onComparerSelect(v.value)} />
      ))}
    </Fragment>
  );
}
